import { findByShortName } from 'chain-list'
import { useRouter } from 'next/router'

const defaultChainId = 1

export const useChainId = function () {
  const { query } = useRouter()
  // This is to keep compatibility with the dashboards that still
  // use queryString. If they were migrated to path parameters
  // the if bottom line can be removed
  if (query.shortName) {
    return findByShortName(query.shortName)?.chainId ?? defaultChainId
  }
  return parseInt(query.chainId ?? defaultChainId, 10)
}
